module.exports = __webpack_public_path__ + "local_taxi.png?fae787ff8b9c43c79846c0f941ab873c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/local_taxi.png
// module id = 744
// module chunks = 0